/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Nobody_Joined_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo waited 20 minutes, but nobody joined the meeting. Did the conversation take place somewhere else?" |
*
* @param {Meeting_Notetaker_Issue_Nobody_Joined_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_nobody_joined_body = /** @type {((inputs?: Meeting_Notetaker_Issue_Nobody_Joined_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Nobody_Joined_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo wachtte 20 minuten, maar er kwam niemand in de meeting. Ging het gesprek ergens anders door?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo a attendu 20 minutes, mais personne n'a rejoint la réunion. La conversation a-t-elle eu lieu ailleurs ?")
	return /** @type {LocalizedString} */ ("Wundo waited 20 minutes, but nobody joined the meeting. Did the conversation take place somewhere else?")
});